import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../assets/images/The Safai Wala 2.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-8xl mx-auto px-6 lg:px-10">
        <div className="flex justify-between items-center h-20">
          {/* ---------- Logo ---------- */}
          <Link to="/" className="flex items-center">
            <img
              src={logo}
              alt="SafaiWale Logo"
              className="h-16 w-auto"
            />
          </Link>

          {/* ---------- Desktop Menu (centered) ---------- */}
          <div className="hidden md:flex flex-1 justify-center items-center space-x-10 text-lg font-medium">
            <Link to="/" className="text-[#e58505] hover:text-[#079dcc] transition">
              Home
            </Link>
            <Link to="/about" className="text-[#e58505] hover:text-[#079dcc] transition">
              About
            </Link>
            <Link to="/service" className="text-[#e58505] hover:text-[#079dcc] transition">
              Services
            </Link>
            {/* <Link to="/career" className="text-[#e58505] hover:text-[#079dcc] transition">
              Career
            </Link> */}
             <Link to="/privacyandpolicies" className="text-[#e58505] hover:text-[#079dcc] transition">
                Privacy & Policies
            </Link>
          </div>

          {/* ---------- Contact Button (right) ---------- */}
          <div className="hidden md:block">
            <Link
              to="/contact"
              className="bg-[#079dcc] text-white px-6 py-2 rounded-full font-semibold hover:bg-[#067fa3] transition-colors"
            >
              Contact
            </Link>
          </div>

        
          {/* ---------- Mobile Toggle ---------- */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden focus:outline-none text-[#e58505]"
            aria-label="Toggle menu"
          >
            {open ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* ---------- Mobile Menu ---------- */}
      {open && (
        <div className="md:hidden bg-white border-t px-6 pb-4 space-y-2 text-lg font-medium">
          {["Home", "About", "Service", "Career"].map((item) => (
            <Link
              key={item}
              to={`/${item === "Home" ? "" : item.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className="block text-[#e58505] hover:text-[#079dcc]"
            >
              {item}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => setOpen(false)}
            className="block bg-[#079dcc] text-white text-center px-4 py-2 rounded-full font-semibold hover:bg-[#067fa3] transition-colors"
          >
            Contact
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
